import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_AUCTION_DETAILS
    SET_ACTIVE_SLIDE_NUMBER
`,
    {
        prefix: 'auctionDetail/'
    }
);
